import {CLStore} from 'common/src/redux/store';
import initializeContentFeedsCopilot from './initializeContentFeedsCopilot';

function initializeContentFeeds(store: CLStore) {
  initializeContentFeedsCopilot(store);
}

export default initializeContentFeeds;
